export const FeedbackReviewIcon = ({ size = 14 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_863_20274)">
        <path
          d="M16 8C16 12.4113 12.4113 16 8 16C6.01933 16 4.122 15.2473 2.66667 13.9467V16H1.33333V12.6667C1.33333 11.9313 1.93133 11.3333 2.66667 11.3333H6V12.6667H3.25133C4.496 13.9287 6.208 14.6667 8 14.6667C11.676 14.6667 14.6667 11.676 14.6667 8H16ZM8 1.33333C9.792 1.33333 11.5033 2.07133 12.748 3.33333H10V4.66667H13.3333C14.0687 4.66667 14.6667 4.06867 14.6667 3.33333V0H13.3333V2.05333C11.878 0.752667 9.98 0 8 0C3.58867 0 0 3.58867 0 8H1.33333C1.33333 4.324 4.324 1.33333 8 1.33333ZM11.7987 6.58133L10.8547 7.12533C10.9407 7.404 11 7.694 11 8.00067C11 8.30733 10.9407 8.59733 10.8547 8.876L11.7987 9.42L11.1333 10.5753L10.1927 10.0333C9.78933 10.468 9.264 10.7833 8.66667 10.92V12.0007H7.33333V10.92C6.736 10.7833 6.21 10.468 5.80733 10.0333L4.86667 10.5753L4.20133 9.42L5.14533 8.876C5.05933 8.59733 5 8.30733 5 8.00067C5 7.694 5.05933 7.404 5.14533 7.12533L4.20133 6.58133L4.86667 5.426L5.80733 5.968C6.21067 5.53333 6.736 5.218 7.33333 5.08133V4.00067H8.66667V5.08133C9.264 5.218 9.79 5.53333 10.1927 5.968L11.1333 5.426L11.7987 6.58133ZM9 8C9 7.44867 8.55133 7 8 7C7.44867 7 7 7.44867 7 8C7 8.55133 7.44867 9 8 9C8.55133 9 9 8.55133 9 8Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_863_20274">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
